import Clock from "../images/clock.svg";
import Teapot from "../images/tetera.svg";
import Termometer from "../images/termometer.svg";
import Cup from "../images/taza.svg";

import "./DetailsHome.css";

function DetailsTea() {
  return (
    <div className="container mt-5 mb-5">
      <hr className="fw-bold mb-5" />
      <div className="row mt-5">
        <div className="col-6 col-md-3 mb-2">
          <div>
            <small>
              <img className="icon" src={Clock} alt="clock"></img>
            </small>
            <p className="fw-bold mt-4">Steep Time</p>
            <span>3'</span>
          </div>
        </div>
        <div className="col-6 col-md-3">
          {" "}
          <div>
            <small>
              <img className="icon" src={Teapot} alt="teapot"></img>
            </small>
            <p className="fw-bold mt-4">Dosage</p>
            <span>1 teabag</span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-2">
          {" "}
          <div>
            <small>
              <img className="icon" src={Termometer} alt="termometer"></img>
            </small>
            <p className="fw-bold mt-4">Water Temperature</p>
            <span>Boiling</span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-2">
          {" "}
          <div>
            <small>
              <img className="icon" src={Cup} alt="cup"></img>
            </small>
            <p className="fw-bold mt-4">Varieties</p>
            <span>More than 20 kinds of tea</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailsTea;
